import { UseMutationOptions } from "@tanstack/react-query";

import { useCreatePinnedView } from "lib/hooks/api/pinned_views/useCreatePinnedView";
import { createSavedViewPinnedEvent } from "lib/savedViewTracking";
import { EventNames, useTracking } from "lib/tracking";

type Params = {
  id: string;
  name: string;
};

export function usePinView(options?: UseMutationOptions<unknown, unknown, Params, unknown>) {
  const { logEvent } = useTracking();
  const { mutate: createPinnedView, ...rest } = useCreatePinnedView();

  const mutate = (
    { id, name }: Params,
    callOptions?: { onSuccess?: () => void; onError?: () => void },
  ) => {
    createPinnedView(
      { input: { savedViewId: id } },
      {
        onSuccess: (data, _vars, ctx) => {
          logEvent(
            EventNames.savedViewPinned,
            createSavedViewPinnedEvent("Pinned View Created", name, "Manual pin", id),
          );
          options?.onSuccess?.(data, { id, name }, ctx);
          callOptions?.onSuccess?.();
        },
        onError: (err, _vars, ctx) => {
          options?.onError?.(err, { id, name }, ctx);
          callOptions?.onError?.();
        },
      },
    );
  };

  return { mutate, ...rest };
}
